import { HttpClient } from "@angular/common/http";
import { Component, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { ITableState, TableResponseModel } from "../../models/table.model";
import { UsersModel } from "../../models/users.model";
import { BaseService } from "../../../base.service";

@Component( {
	template: ""
} )

export class UsersTableService extends BaseService<UsersModel> {

	constructor(
		@Inject( HttpClient ) http
	) {
		super( http );
	}

	/**
	 * Handle create address
	 * @param item : Address data object
	 * @returns
	 */
	createUser( item: UsersModel ): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.ORGANISATION.ADDRESS.CREATE;
		// return this.create(item, url);
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	 */
	findUsers( tableState: ITableState ): Observable<TableResponseModel<UsersModel>> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.USERS.SEARCH;
		return this.getItems( url );
	}

	/**
	 * Delete list of items by ids
	 */
	deleteUsers( ids: number[] = [] ): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.USERS.DELETE;
		// return this.deleteItems(ids, url);
	}
}
